import React from 'react'
import SortBtn from './SortBtn'

export default function TabHeader({data,active,setActive}) {
  return (
    <div className='w-full bg-white border-b-[2px] border-b-[1px solid #d3d3d3] flex justify-between px-4 md:px-6'>
        <div className='flex justify-start'>
        {
            data.map((item,index)=>
            {
                return <div onClick={()=>setActive(item.value)} className={` after:block py-2 px-2 md:py-2 md:px-3 relative cursor-pointer ${active === item.value ? 'after:w-full after:bg-[#0560FB] after:h-[3px] after:bottom-[-1px] after:left-0 after:absolute group active' : ''}`}>
                    <p className='text-[12px] md:text-[13px] font-medium md:font-semibold text-gray-500 capitalize tracking-[0] md:tracking-[-.35px] group-[.active]:text-[#0560FB]'>{item.label}</p>
                </div>
            })
        }
        </div>
        <div>
        </div>
    </div>
  )
}
